import React from 'react';
import UsersManagement from '../components/UsersManagement';

export default function AdminPanel() {
  return <UsersManagement mode="admin" />;
}
